module.exports = __webpack_public_path__ + "img/carousel-clientes-15.e0f7c766.png";